// extracted by css-extract-rspack-plugin
var _1 = "table-UvGRK4";
export { _1 as "table" }
